<template>
<div class='bodyer protocol'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <img src='/static/image/icon/title-icon-service.png' class='icon-img'>法律声明
                </div>
            </div>
        </div>
    </div>

    <article>
        <div class='container'>
            <div class='title'>重庆应答网络科技有限公司（“应答网络”）法律声明</div>
            <p>应答网络拥有www.unnda.com相关网页的HTML、网页内所有内容、素材以及相对应的提供的产品和/或服务的版权，或与应答网络运营的网络游戏网页的内容提供者共同拥有该网页的HTML、该网页的内容、该网页素材以及相对应的提供的产品和/或服务的版权。这些页面以及相对应的提供的产品和/或服务中涉及的运营标志和游戏品牌均系应答网络以及相关游戏开发商所有的注册商标，受中国法律法规和中国加入的所有知识产权方面的国际条约保护。</p>
            <p>未经应答网络的明确书面许可，对于www.unnda.com网站以及应答网络运营的网络游戏网页上的任何内容、素材，任何人不得复制或在非www.unnda.com所属的服务器上做镜像； </p>
            <p>对于应答网络以及相关游戏开发商所有的注册商标，任何人不得擅自使用。 </p>
            <p>未经应答网络的明确书面许可，任何单位及个人不得以任何方式或理由对上述HTML、产品、服务、内容的全部或任何部分进行使用、复制、修改、抄录、转载、传播或与其它产品捆绑使用、销售。</p>
            <p>未经应答网络的明确书面许可，在应答网络以及应答网络运营的网络游戏的开发商版权所有的HTML、内容、素材以及相对应的提供的产品和/或服务基础上创作的任何改编作品的版权均归应答网络以及应答网络运营的网络游戏的开发商所有。改编人具有署名权。任何人（包括改编人本人）不得以任何形式对改编作品转让、复制、转载、传播、摘编、出版、发行、许可使用等。</p>
            <p>凡侵犯应答网络以及应答网络运营的网络游戏的开发商之知识产权的，应答网络和/或应答网络运营的网络游戏的开发商必依法追究其法律责任。</p>
            <p>明令禁止使用游戏私服和外挂，对任何涉嫌使用私服和外挂的用户，应答网络均有权保留依据用户协议进行相应处罚的权利。</p>
            <p>除本网站注明之服务条款外：应答网络对本网站上所有内容包括但不限于网站运营或本网站上的信息、内容、材料或产品，不提供明示或暗示的担保。由所适用法律许可，应答网络否认所有明示或暗示的担保，包括但不限于为特定目的做的商务暗示担保。应答网络对任何损失或任何由于使用本网站信息及应答网络游戏和产品而引起的损失，包括但不限于直接的，间接的，偶然的、惩罚性的和引发的损失，不承担责任。</p>
        </div>
    </article>
</div>
</template>

<script type="text/javascript">
export default {
    created : function(){
        window.scrollTo(0, 0)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/about/Law.vue